import React from "react"
import intl from "react-intl-universal"
import { Flex } from "@stardust-ds/react"
import Button from "../../../../../../atoms/Button"
import ModalComponent from "../../../../components/ModalComponent"
import styles from "./index.module.scss"

function transformRunNumber(runNumber) {
  return runNumber < 10 ? `0${runNumber}` : runNumber
}

const ModalSeeAllRuns = ({ fnOnClose, oControlLevel }) => {
  if (!oControlLevel) return null

  const { level, manual_average } = oControlLevel

  const startRun = manual_average?.abetweeen_run?.[0]?.eqpanltrun_number
  const endRun = manual_average?.abetweeen_run?.[1]?.eqpanltrun_number

  return (
    <ModalComponent
      title={intl.get("ciq.release_details.automatic_calc_modal.title", {
        level,
      })}
      fnCloseModal={fnOnClose}
      size="sm"
    >
      <Flex width="100%" flexDirection="column" gap="16px" style={{ marginBottom: -32 }}>
        <p className={styles.label}>
          {intl.get("ciq.release_details.see_all_runs_modal.start_run")}:{" "}
          <span>{transformRunNumber(startRun)}</span>
        </p>
        <p className={styles.label}>
          {intl.get("ciq.release_details.see_all_runs_modal.end_run")}:{" "}
          <span>{transformRunNumber(endRun)}</span>
        </p>
        <Flex flexDirection="column" width="100%" gap="8px">
          <p className={styles.label}>
            {intl.get("ciq.release_details.see_all_runs_modal.disregard_runs")}
          </p>
          <Flex
            className={styles.disgardRunsList}
            alignItems="flex-start"
            justifyContent="flex-start"
            gap="8px"
            flexWrap="wrap"
          >
            {manual_average?.adisregard_run?.map((run) => (
              <div key={`disgard-run-${run.eqpanltrun_nid}`}>{transformRunNumber(run.eqpanltrun_number)}</div>
            ))}
          </Flex>
        </Flex>
        <Button variant="outline" onClick={fnOnClose} className={styles.closeButton}>
          {intl.get("cap_close")}
        </Button>
      </Flex>
    </ModalComponent>
  )
}

export default ModalSeeAllRuns
